import { useFormContext } from 'react-hook-form'

import { Switch } from 'components/Form'
import { useDataForAdUnitBidderSwitch } from 'features/globalSetup'
import { AdUnitBidderSlice } from 'features/inventory/ad-unit/forms/PrebidStackForm'
import { Schema } from 'features/inventory/ad-unit/forms/PrebidStackForm/schema'
import { useAbility } from 'providers/casl'
import { isDisabledByYieldbirdDenied, isDisabledByYieldbirdRequested } from '../../utils'

type Props = Pick<
  AdUnitBidderSlice,
  'accountType' | 'id' | 's2sRequiredParams' | 'workspaceBidderStatus'
>

export const S2sEnabledCell = ({
  accountType,
  id,
  s2sRequiredParams,
  workspaceBidderStatus,
}: Props): React.JSX.Element => {
  const ability = useAbility()
  const { control } = useFormContext<Schema>()

  const { isDisabled, tooltip } = useDataForAdUnitBidderSwitch({
    isDisabledByAuth:
      ability.cannot('update', 'AdUnit') || ability.cannot('update', 'GlobalSetupFeature-bidder'),
    isDisabledByRequiredParams: !s2sRequiredParams,
    isDisabledByYieldbirdDenied: isDisabledByYieldbirdDenied(accountType, workspaceBidderStatus),
    isDisabledByYieldbirdRequested: isDisabledByYieldbirdRequested(
      accountType,
      workspaceBidderStatus,
    ),
    paramsKind: 's2s',
  })

  return (
    <Switch<Schema>
      control={control}
      disabled={isDisabled}
      name={`adUnitBiddersAttributes.${id}.s2sEnabled`}
      tooltip={tooltip}
      tooltipMode='wrap'
    />
  )
}
